import React, { useContext, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import { sendRestorePasswordOTP } from 'actions/profile';
import useOnNavigationBack from 'hooks/useOnNavigationBack';
import { RestorePasswordContext } from './RestorePasswordContext';
import Header from '../common/Header';
import EmailForm from '../common/EmailForm';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const i18nScope = 'authorizationRestorePasswordEmailPage';
const SECTION_NAME = 'EMAIL_INPUT';

const AuthorizationRestorePasswordEmailPage = () => {
  const dispatch = useDispatch();
  const { contextState, setContextState } = useContext(RestorePasswordContext);
  const onSubmit = useCallback(
    (email) => {
      innerAnalyticsVolia.postEvent({
        eventGroup: 'credentials recovery screen',
        eventName: 'click send password',
        eventValue: 'login type="email"',
      });
      setContextState((state) => ({ ...state, email }));
      dispatch(sendRestorePasswordOTP({ email, errorModal: { returnFocusTo: `@${SECTION_NAME}` } }));
    },
    [dispatch, setContextState],
  );

  useOnNavigationBack(() => setContextState((state) => ({ ...state, email: '' })));

  return (
    <>
      <Header title={i18n.t(`${i18nScope}.title`)} description={i18n.t(`${i18nScope}.description`)} />
      <EmailForm
        initialValue={contextState.email}
        placeholder={i18n.t(`${i18nScope}.emailPlaceholder`)}
        invalidMessage={i18n.t(`${i18nScope}.emailInvalid`)}
        analyticsEventGroup={'credentials recovery screen'}
        analyticsEventName={'click send password'}
        buttonLabel={i18n.t(`${i18nScope}.next`)}
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default AuthorizationRestorePasswordEmailPage;
